import React, { Component } from "react";
import {
  withStyles,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  CircularProgress,
} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import { styles } from "./prs-popup.css.js";
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import PublicIcon from '@material-ui/icons/Public';
import CloseIcon from "@material-ui/icons/Close";
import PrsLogo from "images/PRS_Logo.png";

// import trackFields from "_module/definition/trackFields";
import { AuthSrc } from "util/AuthSrc";
import { connect } from "react-redux";
import moment from "moment";
import { MdCheckCircle, MdDangerous } from "react-icons/md";
import Moment from "react-moment";
import PrsSearchButton from "util/prs-search/prs-search-button/PrsSearchButton.js";
import { prsSearchRefreshDataType } from "util/prs-search/const.js";
import { helpModules } from "modules/ml-admin/help-admin/help-view/Const.js";
import Confirm from "util/Confirm.js";
import { deepCopyFunction, userDisplay, userDisplayPrsPopUp } from "util/CommonFunc.js";
import { PageTableType } from "redux/Types.js";
import MlPrsSearch from "util/prs-search/MlPrsSearch.js";
import clsx from "clsx";
import { DurationDisplayText } from "util/DurationDisplay.js";
class PRSPopup extends Component {
  constructor(props) {
    super();
    this.state = {
      popOutOpen: false,
      unlinkLoading: false,
      createPrsTrackLoading: false,
      mechanicalOverride: "false",
      prsHistoryData: [],
      prsTrackData: null,
      historyId: null,
      customTrack: null,
      createPrsManualTrackLoading: false,
    };
  }

  componentDidMount() {
    // const {
    //   prsHistorySearch,
    //   mbTrackData
    // } = this.props;

    // prsHistorySearch(mbTrackData.id,(data,error)=>{
    //   console.log("history",data,error);
    // });
  }

  handleOpen = (e) => {
    this.setState({ popOutOpen: true });
    const {
      prsHistorySearch,
      mbTrackData,
      prsTrackData
    } = this.props;

    this.setState({ prsTrackData: prsTrackData });
    prsHistorySearch(mbTrackData.dhTrackId, (data, error) => {
      if (data) this.setState({ prsHistoryData: data.filter(d => d.status != 1).sort((a, b) => new Date(b.date_created) - new Date(a.date_created)) });
    });

    if (mbTrackData && mbTrackData.prsMechanicalOverride) {
      this.setState({ mechanicalOverride: "true" });
    }

    this.setState({ customTrack: { trackTitle: mbTrackData.trackTitle, performer: mbTrackData.performer ? mbTrackData.performer : [] } });
  };

  onClose = (e) => {
    this.setState({ popOutOpen: false, prsTrackData: null, prsHistoryData: [], historyId: null, mechanicalOverride: "false" });
  }

  loadMbTrackData = (field, data) => {
    const {
      orgRuntime: {
        runtime: {
          _trackMusicOrigins

        }
      },
      mbTrackData
    } = this.props;
    let val = data;
    switch (field) {
      case "duration":
        val = DurationDisplayText({ seconds: data }) || "";
        break;
      case "musicOrigin":
        val = Object.values(_trackMusicOrigins).find((e) => e.id == data)?.label ?? "";
        break;
      case "dateLastEdited":
        val = `${mbTrackData && mbTrackData?.lastEditedBy?.toString() && userDisplayPrsPopUp(mbTrackData.lastEditedBy.toString()) != "" ? userDisplayPrsPopUp(mbTrackData.lastEditedBy.toString()) : mbTrackData.lastEditedBy == 0 ? "System" : mbTrackData.lastEditedBy == -1 ? "Soundmouse PRS Check" : 'N/A'} - ${moment(data).format("DD/MM/YYYY")}` ||
          "";
        break;
      default:
        val = data;
    }

    return val
  }

  loadPRSTrackData = (field, data) => {
    const {
      orgRuntime: {
        runtime: {
          _trackMusicOrigins

        }
      }
    } = this.props;
    const { prsTrackData } = this.state;
    let val = data;

    switch (field) {
      case "prsRestricted":
        val = data == true ? "Yes" : data == false ? "No" : "";
        break;
      case "duration":
        val = DurationDisplayText({ seconds: data }) || "";
        break;
      case "dateEdited":
        val = `${moment(data).format("DD/MM/YYYY")} - ${prsTrackData && prsTrackData.userId && userDisplayPrsPopUp(prsTrackData.userId.toString()) != "" ? userDisplayPrsPopUp(prsTrackData.userId.toString()) : prsTrackData.userId == 0 ? "System" : prsTrackData.userId == -1 ? "Soundmouse PRS Check" : 'N/A'}` ||
          "";
        break;
      case "musicOrigin":
        val = Object.values(_trackMusicOrigins).find((e) => e.id == data)?.label ?? data;
        break;
      case "prsmatchPercentages":
        if (!data || data == null) {
          val = "";
        }
        else {
          let percentage = 0;
          if (Array.isArray(data)) {
            percentage = data.reduce((sum, item) => sum + item.percentage, 0);

          }
          val = percentage / data?.length || 1;

        }
        break;
      default:
        val = data;
    }

    return val
  }

  handleOverrideChange = (e) => {
    const {
      mbTrackData,
      popoutFor
    } = this.props;
    if (e.target.value == "true") {
      this.setState({ mechanicalOverride: "true" });
      this.prsMechanicalOverride({ trackId: popoutFor && (popoutFor == PageTableType.CLEARANCE_TRACKS || popoutFor == PageTableType.CLEARANCE_FORM_TRACKS) ? mbTrackData.skyMlId : mbTrackData.id, mechanicalOverride: true });
    }
    else if (e.target.value == "false") {
      this.setState({ mechanicalOverride: "false" });
      this.prsMechanicalOverride({ trackId: popoutFor && (popoutFor == PageTableType.CLEARANCE_TRACKS || popoutFor == PageTableType.CLEARANCE_FORM_TRACKS) ? mbTrackData.skyMlId : mbTrackData.id, mechanicalOverride: false });
    }


  }

  prsMechanicalOverride = (pData) => {
    const { prsmechanicaloverride, mbTrackData } = this.props;

    if (prsmechanicaloverride) {
      prsmechanicaloverride(pData, (data, error) => {
        if (data) {
          mbTrackData["prsMechanicalOverride"] = pData.mechanicalOverride;
        }
      });
    }

  }

  handleUnkinkPrsMatch = () => {
    const {
      prsTrackUnlink,
      updatePrsData,
      mbTrackData,
      popoutFor,
      prsHistorySearch
    } = this.props;

    this.setState({ unlinkLoading: true, unlinkMessageOpen: false });
    prsTrackUnlink("Unlink in progress...", { trackId: popoutFor && (popoutFor == PageTableType.CLEARANCE_TRACKS || popoutFor == PageTableType.CLEARANCE_FORM_TRACKS) ? mbTrackData.skyMlId : mbTrackData.id }, (data, error) => {
      this.setState({ unlinkLoading: false, historyId: null });
      if (data) {
        this.setState({ prsTrackData: null });
        updatePrsData(mbTrackData.id, null);
        prsHistorySearch(mbTrackData.dhTrackId, (data, error) => {
          if (data) this.setState({ prsHistoryData: data.filter(d => d.status != 1).sort((a, b) => new Date(b.date_created) - new Date(a.date_created)) });
        });
      }
    });
  }


  getPopoutContent = () => {
    const {
      classes,
      mbTrackData,
      prsTrackUnlink,
      PRSHistoryLoading,
      prsSetHistory,
      CreatePrsTrack,
      prsHistorySearch,
      CreatePrsManualMatchTrack,
      updatePrsData,
      mlsearch,
      orgRuntime: {
        runtime: { _trackFields: trackFields, _prsPopupConfig },
      },
    } = this.props;
    const { mechanicalOverride, prsHistoryData, prsTrackData, createPrsManualTrackLoading } = this.state;
    return (
      <>
        <Confirm
          name="unlinkDialog"
          classes
          isOpen={this.state.unlinkMessageOpen}
          title="Confirmation Alert"
          content="Are you sure, you want to unlink the PRS match?"
          confirm="Yes"
          cancel="No"
          onConfirm={(e) => this.handleUnkinkPrsMatch()}
          onCancel={(e) => this.setState({ unlinkMessageOpen: false })}
        />
        <Grid container spacing={3}>
          <Grid item xs={3}>

            <div>
              <label
                className={"leftLabel"}
                aria-label="Input field media library track"
              >
                Media Library Track
              </label>
              <TextField
                aria-label={""}
                className={"popInput"}
                value={mbTrackData?.trackTitle || ""}
                disabled
                onChange={(event) => {

                }}
                onBlur={(e) => {
                }}
                // onKeyDown={this.onKeyDown}
                // className={}
                InputLabelProps={{
                  classes: {
                    root: classes.tableInputLabel,
                    focused: classes.tableInputFocused,
                  },
                }}
                inputProps={{
                  "aria-label": "MediaLibTrack",
                }}
                InputProps={{
                  classes: {
                    root: classes.tableInputOutlinedInput,
                    focused: classes.tableInputFocused,
                    notchedOutline: classes.tableNotchedOutline,
                  },
                }}
                variant="outlined"
              />
            </div>
            {!prsTrackData || (prsTrackData && prsTrackData.algorithm && prsTrackData.algorithm == "Sky_PRS_Match") ? (
              <div>
                <label
                  className={"leftLabel"}
                  aria-label="Input field matched prs track"
                >
                  Sky-PRS Track
                </label>
                {prsTrackData && prsTrackData.algorithm && prsTrackData.algorithm == "Sky_PRS_Match" && (
                  <TextField
                    className={"popInput"}
                    aria-label={""}
                    value={prsTrackData?.trackTitle || ""}
                    // disabled={isDisable || null}
                    onChange={(event) => {

                    }}
                    onBlur={(e) => {
                    }}
                    // onKeyDown={this.onKeyDown}
                    // className={}
                    InputLabelProps={{
                      classes: {
                        root: classes.tableInputLabel,
                        focused: classes.tableInputFocused,
                      },
                    }}
                    inputProps={{
                      "aria-label": "MediaLibTrack",
                    }}
                    InputProps={{
                      classes: {
                        root: classes.tableInputOutlinedInput,
                        focused: classes.tableInputFocused,
                        notchedOutline: classes.tableNotchedOutline,
                      },
                    }}
                    variant="outlined"
                  />
                )}

                <div className={"flexButtons"}>
                  <Button size="small" className={"globalCreateSaveButton"}
                    disabled={prsTrackData && prsTrackData.algorithm && prsTrackData.algorithm == "Sky_PRS_Match"}
                    onClick={() => {
                      this.setState({ createPrsTrackLoading: true });
                      CreatePrsTrack({ trackId: mbTrackData.dhTrackId }, (data, error) => {
                        this.setState({ createPrsTrackLoading: false });
                        if (data) {
                          // prsTrackData = prsData?.PRSTrack;
                          this.setState({ prsTrackData: data });
                          updatePrsData(mbTrackData.id, data);
                        }
                        prsHistorySearch(mbTrackData.dhTrackId, (data, error) => {
                          // console.log("history",data,error);
                          if (data) this.setState({ prsHistoryData: data.filter(d => d.status != 1).sort((a, b) => new Date(b.date_created) - new Date(a.date_created)) });
                        });

                      });
                    }}
                  >
                    Create Track
                    {this.state.createPrsTrackLoading && (
                      <CircularProgress className={classes.insideLoader} />
                    )}
                  </Button>
                </div>

              </div>
            ) : null}
            <div>
              <label
                className={"leftLabel"}
                aria-label="Input field matched prs track"
              >
                {"Matched PRS Track"}
              </label>
              {prsTrackData && prsTrackData.algorithm && prsTrackData.algorithm != "Sky_PRS_Match" ? (
                <TextField
                  className={"popInput"}
                  aria-label={""}
                  value={prsTrackData?.trackTitle || ""}
                  // disabled={isDisable || null}
                  onChange={(event) => {

                  }}
                  onBlur={(e) => {
                  }}
                  // onKeyDown={this.onKeyDown}
                  // className={}
                  InputLabelProps={{
                    classes: {
                      root: classes.tableInputLabel,
                      focused: classes.tableInputFocused,
                    },
                  }}
                  inputProps={{
                    "aria-label": "MediaLibTrack",
                  }}
                  InputProps={{
                    classes: {
                      root: classes.tableInputOutlinedInput,
                      focused: classes.tableInputFocused,
                      notchedOutline: classes.tableNotchedOutline,
                    },
                  }}
                  variant="outlined"
                />
              ) : (
                <div className={classes.emptyMsg}>
                  No existing match found. Please use PRS auto match or PRS manual match to find a match.
                </div>
              )}
              <div className={"flexButtons"}>
                <Button size="small" className={"globalCreateSaveButton"} title={"Unlink"} disabled={prsTrackData == null} onClick={() => {
                  this.setState({ unlinkMessageOpen: true });
                }}>Unlink {this.state.unlinkLoading && (
                  <CircularProgress className={classes.insideLoader} />
                )}</Button>
              </div>
            </div>
            <label
              className={"leftLabel"}
              aria-label="History Matches"
            >
              History Matches
            </label>
            <div className={clsx(
              (prsTrackData && (prsTrackData.algorithm && prsTrackData.algorithm === "Sky_PRS_Match") ? "marginTopTen": "marginTopTenSmall"),
             (prsTrackData && prsTrackData.algorithm && prsTrackData.algorithm != "Sky_PRS_Match" ? "prsMatched" : null  ) )}>

              <div className={classes.hisContainer}>
                <div className="hisInnerContainer">


                  {PRSHistoryLoading && (
                    <CircularProgress className={classes.insideLoader} />
                  )}
                  {prsHistoryData && prsHistoryData.length > 0 && prsHistoryData.map((item, index) => {
                    let prsData = JSON.parse(item.prs_track);
                    return (
                      <div key={index} className={"flexHistory"}>
                        <div className={this.state.historyId && this.state.historyId == item.id ? "yellowTerm smallTxt active" : "yellowTerm smallTxt"} onClick={(e) => {
                          this.setState({ prsTrackData: prsData?.PRSTrack, historyId: item.id });
                          //Set history to current data
                          // prsSetHistory({ historyId: item.id, trackId: mbTrackData.dhTrackId }, (data, error) => {
                          //   if (data) {
                          //     // prsTrackData = prsData?.PRSTrack;
                          //     this.setState({ prsTrackData: prsData?.PRSTrack, historyId: item.id });
                          //     updatePrsData(mbTrackData.id, prsData?.PRSTrack);
                          //   }
                          // });

                        }}>
                          <span title={prsData?.PRSTrack?.trackTitle}>{prsData?.PRSTrack?.trackTitle}</span>
                          <span><Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>{prsData?.PRSTrack?.dateEdited}</Moment></span>
                        </div>
                      </div>
                    )
                  })
                  }
                </div>
              </div>
            </div>
            <div className={classes.updateMatchesContainer}>
              <label
                className={"leftLabel"}
                aria-label="History Matches"
              >
                Update Matches
              </label>
              <div className={"flexButtons"}>
                <PrsSearchButton
                  classes={classes}
                  trackID={mbTrackData.dhTrackId}
                  prsSearchRefreshDataType={prsSearchRefreshDataType.TRACK}
                  isButton={true}
                  isDisabled={mbTrackData.prsMechanicalOverride || this.state.mechanicalOverride == "true" || false}
                  callBack={(data) => {
                    if (data && data.prsTrack) {
                      this.setState({ prsTrackData: data.prsTrack });
                      updatePrsData(mbTrackData.id, data?.prsTrack);
                    }
                  }}
                  handleClose={() => {
                    prsHistorySearch(mbTrackData.dhTrackId, (data, error) => {
                      if (data) this.setState({ prsHistoryData: data.filter(d => d.status != 1).sort((a, b) => new Date(b.date_created) - new Date(a.date_created)) });
                    });
                  }}
                />
                <MlPrsSearch
                  alwaysActive={true}
                  withBackBtn={true}
                  importLoading={createPrsManualTrackLoading}
                  buttonLabel="PRS Manual Match"
                  actionLabel="Import Data"
                  customTrack={this.state.customTrack}
                  onBack={() => {
                    // this.isMlSearch = false;
                    // this.isPrsSearch = false;
                    // this.isCustomTrack = true;
                  }}
                  // customChanged={this.state.customChanged}
                  setCustomChanged={() => {
                    this.setState({
                      customChanged: false
                    })
                  }}
                  // closeAddTrack={this.closeDialog} 
                  mlSearch={mlsearch}
                  importData={(selectedPrsTrack) => {
                    const { customTrack } = this.state;
                    this.setState({ createPrsManualTrackLoading: true });let oData = {
                      trackId: mbTrackData.dhTrackId,
                      recordingId: parseInt(selectedPrsTrack.recordingId),
                      tuneCode: selectedPrsTrack.prs,
                      isrc: selectedPrsTrack.isrc,
                      // trackId: "603d8b57-ba2a-4038-9e47-7c6eae6fcefc",
                      // recordingId: parseInt("0028752423"),
                      // tuneCode: "2473265H",
                      // isrc: "2473265H",
                    };

                    CreatePrsManualMatchTrack(oData, (data, error) => {
                      this.setState({ createPrsManualTrackLoading: false });
                      if (data && data.prsTrack) {
                        this.setState({ prsTrackData: data.prsTrack });
                        updatePrsData(mbTrackData.id, data?.prsTrack);

                      }
                    })

                  }}
                />
              </div>

            </div>
          </Grid>
          <Grid item xs={9}>
            <Grid container className="darkBG">
              <Grid item xs={5}>
                <Paper class="blueTerm"><div title="PRS Track" class="titleCase">PRS Track</div>
                </Paper>
              </Grid>
              <Grid item xs={3}>

                <div class="yellowTerm">
                  <div class="titleCase" style={{ minHeight: 23 }}></div>
                </div>
              </Grid>
              <Grid item xs={4}>
                <Paper class="mbTerm" style={{ marginLeft: "-12px" }}><div title="MusicBox Track" class="titleCase">MusicBox Track</div>
                </Paper>
              </Grid>


              {/* Edited By Asitha */}
              <Grid container alignItems="center" className="fixedHeight">
                {_prsPopupConfig && _prsPopupConfig.length > 0 && _prsPopupConfig.map(t => {
                  return (
                    <>
                      <Grid container alignItems="center" className="borderedRow">
                        <Grid item xs={5}>
                          <Paper class="blueTerm">
                            <span title={prsTrackData && (prsTrackData[t.prsField] ? (t.id == "mechanicalRight" && prsTrackData[t.prsField] == false) || (Array.isArray(prsTrackData[t.prsField]) && t.id != "percentage") ? null : this.loadPRSTrackData(t.prsField, prsTrackData[t.prsField]) : "N/A")}>{prsTrackData && (prsTrackData[t.prsField] || (t.id == "mechanicalRight" && prsTrackData[t.prsField] == false)) ?
                              // t.id == "mechanicalRight" && prsTrackData[t.prsField] == true && prsTrackData.ownersMech.length > 0 ?
                              t.id == "mechanicalRight" ?
                                (
                                  <>
                                    {prsTrackData.ownersMech && prsTrackData.ownersMech.length > 0 ?
                                      prsTrackData.ownersMech.map(i => {
                                        return (
                                          <>
                                            <div>
                                              <span title={i?.name} className={mbTrackData.prsMechanicalOverride ? "redText" : "blueTerm"}>{i?.name}</span> <span>{i?.isPrs == true ? <MdCheckCircle class="greenIcon popIcons" /> : i?.isPrs == false ? <MdDangerous class="redIcon popIcons" /> : ""}</span>
                                            </div>

                                          </>
                                        )
                                      }) : ""}
                                    {prsTrackData[t.prsField] == false && prsTrackData.ownersMech && prsTrackData.ownersMech.length > 0 ?
                                      <div className={"flexOverridden"}>
                                        <label>Override Option : </label>
                                        <FormControl component="fieldset">

                                          <RadioGroup
                                            row
                                            aria-label="OverrideOption"
                                            name="OverrideOption"
                                            value={mechanicalOverride}
                                            onChange={this.handleOverrideChange}
                                            className={classes.setofRadio}
                                          >
                                            <FormControlLabel
                                              value={"true"}
                                              control={<Radio />}
                                              label="On"
                                            />
                                            <FormControlLabel
                                              value={"false"}
                                              control={<Radio />}
                                              label="Off"
                                              className={"lastRadio"}
                                            />
                                          </RadioGroup>
                                        </FormControl>

                                      </div>
                                      : null}

                                  </>
                                )

                                // : t.id == "mechanicalRight" && prsTrackData[t.prsField] == false ?
                                //   ""
                                : Array.isArray(prsTrackData[t.prsField]) && t.id != "percentage" ?

                                  prsTrackData[t.prsField].map(item => {
                                    item = item.replace(/&amp;/gi, "&");
                                    return (
                                      <div title={item}>
                                        {item}
                                      </div>
                                    )
                                  })

                                  : this.loadPRSTrackData(t.prsField, prsTrackData[t.prsField]) : "N/A"}</span>
                          </Paper>
                        </Grid>
                        <Grid item xs={3}>
                          <div class="yellowTerm">
                            {t.id == "mechanicalRight" ?
                              <>
                                <span title={t.label}>{t.label}</span>
                                <div class="flexInfo">
                                  <div><MdCheckCircle class="greenIcon popIcons" />[Y] </div>
                                  <div><MdDangerous class="redIcon popIcons" />[N]</div>
                                </div>
                              </>
                              :
                              <span title={t.label}>{t.label}</span>
                            }
                          </div>
                        </Grid>
                        <Grid item xs={4}>
                          <Paper class="mbTerm">
                            <span title={mbTrackData[t.mbField] &&
                              Array.isArray(mbTrackData[t.mbField]) ? null : mbTrackData[t.mbField] ? this.loadMbTrackData(t.mbField, mbTrackData[t.mbField]) : "N/A"}>{mbTrackData[t.mbField] ?
                                Array.isArray(mbTrackData[t.mbField]) ?

                                  mbTrackData[t.mbField].map(item => {
                                    return (
                                      <div title={item}>
                                        {item}
                                      </div>
                                    )
                                  })
                                  :
                                  this.loadMbTrackData(t.mbField, mbTrackData[t.mbField]) : "N/A"}</span>
                          </Paper>
                        </Grid>

                      </Grid>


                    </>
                  )
                }
                )}
              </Grid>
              {/* Edited By Asitha */}


            </Grid>
          </Grid>
        </Grid>








      </>
    )
  }

  render() {
    const {
      classes,
      mbTrackData,
      orgRuntime: {
        runtime: {
          _prsPopupConfig

        }
      },
    } = this.props;

    const {
      popOutOpen,
    } = this.state;
    return (
      <>

        <Button
          aria-label="Open Prs popup data"
          title="Open PRS Popup "
          // className={classes.globalCreateAddButton}
          onClick={this.handleOpen}
        // disabled={!data}
        >
          <img src={PrsLogo} width={35} /> <span class="hideInside">Compare</span>
        </Button>

        <Dialog
          open={popOutOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          // className={classes.dialogWrapper}                
          className={"dialogBox maxHeightAuto"}
          maxWidth={"lg"}

        >
          <DialogTitle className={"dialogTitleBar"} id="alert-dialog-title">
            Compare Track
            <Button
              aria-label="Close"
              className={"close"}
              title="Close"
              onClick={this.onClose}
            >
              <CloseIcon />
            </Button>
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.getPopoutContent()}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </>
    );
  }

}


const mapStateToProps = (state) => ({
  orgRuntime: state.orgRuntime,
});


export default connect(
  mapStateToProps,
  {
  }
)(withStyles(styles)(PRSPopup));
